import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';

const AsyncSearchResults = Load(() => import(/* webpackChunkName: "search-page" */'./containers/SearchResultsContainer'), {}, true);

const SearchRoutes = [
  (
    <NavigationableLayout
      subNavbar="experienceFilters"
      key="searchresults"
      path={`${basePath}/s/*`}
      component={AsyncSearchResults}
      showSearchInNavbar
      showBottomNavigation
    />
  )
];

export default SearchRoutes;
